import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../components/Layout";
import BusinessDashboard from "../pages/Business/BusinessDashboard";
import NotFound from "../pages/NotFound";
import BusinessDetails from "../pages/Business/BusinessDetails";
import ViewFeedback from "../pages/ViewFeedback";
import FeedbackReports from "../pages/FeedbackReports";
import { HourglassEmpty as ComingSoonIcon, Build as UnderConstructionIcon } from "@mui/icons-material";

const BusinessRoutes = () => (
  <Routes>
    {/* Main Business Layout */}
    <Route element={<Layout title="Business Dashboard" linkToNavigate="/business" />}>
      <Route path="/" element={<BusinessDashboard />} />
      <Route path="/details" element={<BusinessDetails />} />
      <Route path="/feedbacks" element={<ViewFeedback />} />
      <Route path="/feedback-stats" element={<FeedbackReports />} />

      {/* Coming Soon Page */}
      <Route
        path="/coming-soon"
        element={
          <NotFound
            message="Coming Soon"
            secondaryMessage="We're working hard to bring this feature to you soon."
            redirectPath="/business"
            buttonText="Back to Dashboard"
            icon={
              <ComingSoonIcon
                sx={{
                  fontSize: "80px",
                  color: "#ff9800", // Orange color for "Coming Soon"
                  marginBottom: "20px",
                }}
              />
            }
          />
        }
      />

      {/* Under Development Page */}
      <Route
        path="/under-development"
        element={
          <NotFound
            message="Under Development"
            secondaryMessage="This feature is currently under development. Please check back later."
            redirectPath="/business"
            buttonText="Back to Dashboard"
            icon={
              <UnderConstructionIcon
                sx={{
                  fontSize: "80px",
                  color: "#4caf50", // Green color for "Under Development"
                  marginBottom: "20px",
                }}
              />
            }
          />
        }
      />
    </Route>

    {/* Fallback 404 Route */}
    <Route
      path="*"
      element={
        <NotFound
          redirectPath="/business"
          message="404: Business Page Not Found"
          secondaryMessage="The page you're looking for does not exist or has been moved."
          buttonText="Back to Dashboard"
        />
      }
    />
  </Routes>
);

export default BusinessRoutes;
